import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/browser';
import reportWebVitals from './reportWebVitals';
import '@fontsource-variable/inter';
import '@fontsource-variable/inter/wght.css';
import './index.css';
import App from './App';
import config from './config';
Sentry.init({
    environment: config.env,
    dsn: config.sentryDns,
    release: "FRONTEND-" + config.version,
});
var root = createRoot(document.getElementById('root'));
root.render(_jsx(App, {}, void 0));
reportWebVitals();
